var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalFundingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#F4F4F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5556 15.654V21.8847M16.0556 15.654V21.8847M19.9444 15.654V21.8847M23.4444 15.654V21.8847M11 23.1308L11 23.7539C11 24.1901 11 24.4081 11.0848 24.5748C11.1593 24.7213 11.2783 24.8404 11.4247 24.9151C11.591 25 11.8088 25 12.2444 25H23.7556C24.1912 25 24.409 25 24.5753 24.9151C24.7217 24.8404 24.8407 24.7213 24.9152 24.5748C25 24.4081 25 24.1901 25 23.7539V23.1308C25 22.6946 25 22.4765 24.9152 22.3099C24.8407 22.1634 24.7217 22.0442 24.5753 21.9696C24.409 21.8847 24.1912 21.8847 23.7556 21.8847H12.2444C11.8088 21.8847 11.591 21.8847 11.4247 21.9696C11.2783 22.0442 11.1593 22.1634 11.0848 22.3099C11 22.4765 11 22.6946 11 23.1308ZM17.73 11.0411L11.9745 12.3218C11.6268 12.3992 11.4529 12.4379 11.3231 12.5315C11.2087 12.6141 11.1188 12.7263 11.0631 12.8561C11 13.0033 11 13.1816 11 13.5383L11 14.4079C11 14.8441 11 15.0621 11.0848 15.2288C11.1593 15.3753 11.2783 15.4944 11.4247 15.5691C11.591 15.654 11.8088 15.654 12.2444 15.654H23.7556C24.1912 15.654 24.409 15.654 24.5753 15.5691C24.7217 15.4944 24.8407 15.3753 24.9152 15.2288C25 15.0621 25 14.8441 25 14.4079V13.5383C25 13.1816 25 13.0033 24.9369 12.8561C24.8812 12.7263 24.7913 12.6141 24.6769 12.5315C24.5471 12.4379 24.3732 12.3992 24.0255 12.3218L18.27 11.0411C18.1692 11.0187 18.1188 11.0074 18.0679 11.003C18.0227 10.999 17.9773 10.999 17.9321 11.003C17.8812 11.0074 17.8308 11.0187 17.73 11.0411Z",
    stroke: "#09041C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalFundingIcon);
export default __webpack_public_path__ + "static/media/total-funding-icon.875bef67955346a639019013fa95f6f5.svg";
export { ForwardRef as ReactComponent };